// extracted by mini-css-extract-plugin
module.exports = {"menuBlock":"Jd","title":"Kd","nav":"Ld","flexCell":"Md","facetLink":"Nd"};